export const BELOW_PLAYER_CONTROLS_RESERVED_HEIGHT_PX = 74;

export function getCanvasWrapperStyles({
    canvasWrapperStyles = {},
    reserveSpaceBelowPlayerControls = false
} = {}) {
    if (!reserveSpaceBelowPlayerControls) {
        return canvasWrapperStyles;
    }

    const baseHeight = canvasWrapperStyles.height ?? "100%";

    return {
        ...canvasWrapperStyles,
        height: `calc(${baseHeight} - ${BELOW_PLAYER_CONTROLS_RESERVED_HEIGHT_PX}px)`,
        marginBottom: `${BELOW_PLAYER_CONTROLS_RESERVED_HEIGHT_PX}px`,
        minHeight: 0,
    };
}
